import React from 'react';
import { BsEnvelope } from "react-icons/bs";
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => {
    return {
        settings: state.settings,
    }
}

function ContactPage(props: any) {
    return (
        <div className="page contact-page">
            <div className="width-100 margin-top-50 text-center">
                <h2>Холбогдох:</h2>
                <br/>
                <p>
                    <a href={props.settings.facebookLink} className="btn-chat" target="_blank" rel="noopener noreferrer">
                      <span className="text xs-hidden">&nbsp;Facebook-р холбогдох</span>
                    </a>
                </p>
                <br/>
                <p>
                    <a href={`tel:${props.settings.supportPhone}`}>
                    <i className="icon icon-phone"></i>
                    +976 {props.settings.supportPhone}
                    </a>
                </p>
                <br/>
                <p>
                    <BsEnvelope className='main'/>
                    &nbsp;
                    <a href={`mailto:${props.settings.supportEmail}`}>{props.settings.supportEmail}</a>
                </p>
            </div>
        </div>
    );
}

export default connect(mapStateToProps)(ContactPage);